export default __webpack_public_path__ + "static/media/hero-logo-2.b6eaef2c.png";